import { Injectable } from '@angular/core';
import { HttpClientWrapper } from '../httpclientwrapper';
import { Observable } from 'rxjs';
import { IsNotNull } from '@apply4u/shared/helpers/common/type-safe-helpers';
import { Recommendation } from '@apply4u/models/recommendation/recommendation';
import { RecommendedList } from '@apply4u/models/recommendation/recommended-list';
import { RecommendationMapping } from '@apply4u/models/recommendation/recommendation-mapping';
import { Job } from '@apply4u/models/search/job';
import { Candidate } from '@apply4u/models/search/candidate';
import { RecommendationResult } from '@apply4u/models/recommendation/recommendation-result';
import { CompanyRegistration } from '@apply4u/models/companyRegistration';

@Injectable({
    providedIn: 'root'
})
export class RecommendationService {

    constructor(private http: HttpClientWrapper) { }

    GetRecommendationAsync(id: number): Observable<Recommendation> {
        return this.http.GetAsync<Recommendation>(this.http.BaseUrl + `api/Recommendation/${id}`);
    }

    GetRecommendationsAsync(
        id?: number,
        title?: string,
        recommendedByUserId?: number,
        isNotifyCandidate?: boolean,
        isNotifyRecruiter?: boolean,
        isNotifyCompany?: boolean,
        isSubmitted?: boolean,
        createdDate?: Date,
        submittedDate?: Date,
        pageNumber?: number,
        pageSize?: number
    ): Observable<RecommendationResult> {
        let requesPramas = "?";

        if (IsNotNull(id)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "id=" + id
        }

        if (IsNotNull(title)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "title=" + title
        }

        if (IsNotNull(recommendedByUserId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendedByUserId=" + recommendedByUserId
        }

        if (IsNotNull(isNotifyCandidate)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isNotifyCandidate=" + isNotifyCandidate
        }

        if (IsNotNull(isNotifyRecruiter)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isNotifyRecruiter=" + isNotifyRecruiter
        }

        if (IsNotNull(isNotifyCompany)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isNotifyCompany=" + isNotifyCompany
        }

        if (IsNotNull(isSubmitted)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isSubmitted=" + isSubmitted
        }

        if (IsNotNull(createdDate)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "createdDate=" + createdDate
        }

        if (IsNotNull(submittedDate)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "submittedDate=" + submittedDate
        }

        if (IsNotNull(pageNumber)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "pageNumber=" + pageNumber
        }

        if (IsNotNull(pageSize)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "pageSize=" + pageSize
        }

        return this.http.GetAsync<RecommendationResult>(this.http.BaseUrl + `api/Recommendation/search${requesPramas}`);
    }

    GetRecommendationsByUserAsync(
        userId: number,
        isJobSeeker: boolean,
        pageNumber?: number,
        pageSize?: number
    ): Observable<RecommendationResult> {
        let requesPramas = "?";

        if (IsNotNull(userId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "userId=" + userId
        }

        if (IsNotNull(isJobSeeker)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "isJobSeeker=" + isJobSeeker
        }

        if (IsNotNull(pageNumber)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "pageNumber=" + pageNumber
        }

        if (IsNotNull(pageSize)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "pageSize=" + pageSize
        }

        return this.http.GetAsync<RecommendationResult>(this.http.BaseUrl + `api/Recommendation/searchByUser${requesPramas}`);
    }

    SaveRecommendationAsync(recommendation: Recommendation): Observable<any> {
        return this.http.PostAsync<any>(this.http.BaseUrl + `api/Recommendation`, recommendation);
    }

    DeleteRecommendationAsync(id: number): Observable<any> {
        return this.http.DeleteAsync<any>(this.http.BaseUrl + `api/Recommendation/${id}`);
    }

    GetRecommendedListAsync(
        recommendedId: number,
        recommendationTypeId: number,
        recommendedByUserId: number
    ): Observable<RecommendedList[]> {
        let requesPramas = "?";

        if (IsNotNull(recommendedId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendedId=" + recommendedId
        }

        if (IsNotNull(recommendationTypeId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendationTypeId=" + recommendationTypeId
        }

        if (IsNotNull(recommendedByUserId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendedByUserId=" + recommendedByUserId
        }

        return this.http.GetAsync<RecommendedList[]>(this.http.BaseUrl + `api/Recommendation/GetRecommendedList${requesPramas}`);
    }

    DeleteByRecommendedIdAsync(recommendationId: number, recommendedId: number, recommendationTypeId: number): Observable<any> {
        let requesPramas = "?";

        if (IsNotNull(recommendationId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendationId=" + recommendationId
        }

        if (IsNotNull(recommendationTypeId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendationTypeId=" + recommendationTypeId
        }

        return this.http.DeleteAsync<any>(this.http.BaseUrl + `api/Recommendation/DeleteByRecommendedId/${recommendedId}${requesPramas}`);
    }

    GetRecommendationMappingAsync(id: number): Observable<RecommendationMapping> {
        return this.http.GetAsync<RecommendationMapping>(this.http.BaseUrl + `api/RecommendationMapping/${id}`);
    }

    GetRecommendationMappingsAsync(
        id: number,
        recommendationId: number,
        recommendedId: number,
        recommendationTypeId: number
    ): Observable<RecommendationMapping[]> {
        let requesPramas = "?";

        if (IsNotNull(id)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "id=" + id
        }

        if (IsNotNull(recommendationId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendationId=" + recommendationId
        }

        if (IsNotNull(recommendedId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendedId=" + recommendedId
        }

        if (IsNotNull(recommendationTypeId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendationTypeId=" + recommendationTypeId
        }

        return this.http.GetAsync<RecommendationMapping[]>(this.http.BaseUrl + `api/RecommendationMapping/search${requesPramas}`);
    }

    SaveRecommendationMappingAsync(recommendationMapping: RecommendationMapping): Observable<any> {
        return this.http.PostAsync<any>(this.http.BaseUrl + `api/RecommendationMapping`, recommendationMapping);
    }

    GetRecommendedJobsAsync(recommendationId: number, userId: number): Observable<Job[]> {
        return this.http.GetAsync<Job[]>(this.http.BaseUrl + `api/Recommendation/GetRecommendedJobs?recommendationId=${recommendationId}&userId=${userId}`);
    }

    GetRecommendedCandidatesAsync(recommendationId: number, userId: number): Observable<Candidate[]> {
        return this.http.GetAsync<Candidate[]>(this.http.BaseUrl + `api/Recommendation/GetRecommendedCandidates?recommendationId=${recommendationId}&userId=${userId}`);
    }

    GetRecommendedCompaniesAsync(
        recommendationId: number,
        loggedInUserId?: number
    ): Observable<CompanyRegistration[]> {
        let requesPramas = "?";

        if (IsNotNull(recommendationId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "recommendationId=" + recommendationId
        }

        if (IsNotNull(loggedInUserId)) {
            requesPramas += (requesPramas == "?" ? "" : "&") + "loggedInUserId=" + loggedInUserId
        }

        return this.http.GetAsync<CompanyRegistration[]>(this.http.BaseUrl + `api/Recommendation/GetRecommendedCompanies${requesPramas}`);
    }
}
